import {gql} from 'apollo-boost'

export const GET_REWARDS = gql `
    query GetRewards {
  getRewards {
    total
    data {
      id
      name
      description
      maxDiscountAmount
      pointMax
      pointMin
      percent
      maxUser
      remainUser
      image
      startDate
      endDate
      status
      rewardType
      userType {
        name
      }
      createdAt
      updatedAt
        createdBy {
          id
        }
        updatedBy {
          id
        }
        minimumOrderQuantity
        freeItemQuantity
      }
  }
}
`

export const GET_REWARDS_V2 = gql `
  query GetRewardsV2 {
  getRewardsV2 {
    data {
      id
      name
      description
      maxDiscountAmount
      pointMax
      pointMin
      percent
      maxUser
      remainUser
      image
      startDate
      endDate
      status
      rewardType
      userType {
        id
        name
      }
      shop {
        id
        name
      }
      createdBy {
          id
        firstName
        lastName
        phone
      }
      updatedBy {
        id
        firstName
        lastName
        phone
      }
      createdAt
      updatedAt
      isDeleted
      code
      minimumOrderAmount
      applyType
      applicableProducts {
        id
        name
      }
      applicableCategories {
        id
        name
      }
      minimumOrderQuantity
      freeItemQuantity
      platform
    }
    total
  }
}
`